export default __webpack_public_path__ + "static/experienceImg6-3b7d299e8dfd1e784c7d2a8216c2dbed.webp";